import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/admin/planning-scopes");

export const Route = createFileRoute("/admin/planning-scopes")({
  head: () => ({
    meta: [
      { title: "Planning scopes — LevelLoad" },
      { name: "description", content: "Planning scopes — LevelLoad transport planning." },
      { property: "og:title", content: "Planning scopes — LevelLoad" },
      { property: "og:description", content: "Planning scopes — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
